var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_6478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84888 11.3333V12.6666C2.84888 13.0202 2.98935 13.3593 3.2394 13.6094C3.48945 13.8594 3.82859 13.9999 4.18221 13.9999H12.1822C12.5358 13.9999 12.875 13.8594 13.125 13.6094C13.3751 13.3593 13.5155 13.0202 13.5155 12.6666V11.3333",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 5.66992L8.18229 2.33659L4.84896 5.66992",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18213 2.66675V10.6667",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_6478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.182129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadGrey);
export default __webpack_public_path__ + "static/media/Icon_Upload_Grey.e5cc9f6640128861f97536e78bdc79f2.svg";
export { ForwardRef as ReactComponent };